import { defineStore } from "pinia";
import { ref, watch } from "vue";

export const useThemeStore = defineStore("theme", () => {
  // Check localStorage or default to light mode
  const isDark = ref(localStorage.getItem("theme") === "dark" || false);

  // Apply theme to document
  const applyTheme = (dark) => {
    if (dark) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
    isDark.value = dark;
  };

  // Toggle theme
  const toggleTheme = () => {
    applyTheme(!isDark.value);
  };

  // Initialize theme on mount
  const initTheme = () => {
    applyTheme(isDark.value);
  };

  // Watch for changes and apply
  watch(isDark, (newValue) => {
    applyTheme(newValue);
  });

  return {
    isDark,
    toggleTheme,
    initTheme,
    applyTheme
  };
});
